// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2KfVW","lightbg":"Card_lightbg__12ETO","darkbg":"Card_darkbg__2PTVN","noBorder":"Card_noBorder__blvFz","outline":"Card_outline__GF2nY"};